import React, { useEffect } from 'react';
import classnames from 'classnames';
import Title from 'components/title';
import anzLogo from 'assets/images/ANZ_logo.webp';
import amexLogo from 'assets/images/AMEX_logo.webp';
import asbLogo from 'assets/images/ASB_logo.webp';
import bnzLogo from 'assets/images/BNZ_logo.webp';
import kiwibankLogo from 'assets/images/Kiwibank_logo.webp';
import westpacLogo from 'assets/images/Westpac_logo.webp';
import { Image } from 'semantic-ui-react';
import { PAGE_VIEW_EVENTS } from 'helpers';
import useTracking from 'hooks/useTracking';
import styles from './exploreCC.scss';
import Slider from 'components/slider';

const PROVIDERS_LIST = [
  {
    key: 'ANZ',
    src: anzLogo,
    name: 'ANZ',
    className: styles.anz,
  },
  {
    key: 'American Express',
    src: amexLogo,
    name: 'American Express',
    className: styles.amex,
  },
  {
    key: 'ASB',
    src: asbLogo,
    name: 'ASB',
  },
  {
    key: 'BNZ',
    src: bnzLogo,
    name: 'BNZ',
    className: styles.bnz,
  },
  {
    key: 'KiwiBank',
    src: kiwibankLogo,
    name: 'KiwiBank',
    className: styles.square,
  },
  {
    key: 'Westpac',
    src: westpacLogo,
    name: 'Westpac',
    className: styles.westpac,
  },
];

const ccSliderSettings = {
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 375,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};

export interface ISelectCardProviderProps {
  providerName?: string;
  selectProvider(providerName: string): void;
}

const SelectCardProvider = ({
  selectProvider,
  providerName,
}: ISelectCardProviderProps) => {
  useTracking(PAGE_VIEW_EVENTS.CreditCard);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Title
          title="Choose your credit card provider"
          subtitle="Each credit card provider has different benefits, select the card you hold."
          subtitleClassName={styles.subtitle}
          className={styles.title}
        />
      </div>
      <div className={styles.providerSelectionList}>
        {PROVIDERS_LIST.map((p) => (
          <div
            key={p.key}
            className={classnames(
              styles.imgContainer,
              p.className,
              providerName === p.name && styles.selected,
            )}
            onClick={() => selectProvider(p.name)}
          >
            <Image src={p.src} rounded={true} alt={p.name} loading="lazy" />
          </div>
        ))}
      </div>
      <div className={styles.providerSelectionListMobile}>
        <Slider settings={ccSliderSettings}>
          {PROVIDERS_LIST.map((p) => (
            <div
              key={p.key}
              className={classnames(
                styles.imgContainer,
                p.className,
                providerName === p.name && styles.selected,
              )}
              onClick={() => selectProvider(p.name)}
            >
              <Image src={p.src} rounded={true} alt={p.name} loading="lazy" />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default SelectCardProvider;
